import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  ASSESSMENT_PROJECT_LIST,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE,
  ASSESSMENT_PROJECT_SEARCH_ASSESSMENT,
  ASSESSMENT_PROJECT_SEARCH_DESTINATION,
  ASSESSMENT_PROJECT_SEARCH_CONTRACT,
  ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE,
  ASSESSMENT_PROJECT_ADD,
  ASSESSMENT_PROJECT_DETAIL,
  ASSESSMENT_PROJECT_UPDATE
} from '../../actions';

import {
  AssessmentProjectListSuccess,
  AssessmentProjectListError,
  AssessmentProjectSearchAssessmentTypeSuccess,
  AssessmentProjectSearchAssessmentTypeError,
  AssessmentProjectSearchAssessmentSuccess,
  AssessmentProjectSearchAssessmentError,
  AssessmentProjectSearchDestinationSuccess,
  AssessmentProjectSearchDestinationError,
  AssessmentProjectSearchContractSuccess,
  AssessmentProjectSearchContractError,
  AssessmentProjectSearchEvaluationStateSuccess,
  AssessmentProjectSearchEvaluationStateError,
  AssessmentProjectAddSuccess,
  AssessmentProjectAddError,
  AssessmentProjectDetailSuccess,
  AssessmentProjectDetailError,
  AssessmentProjectUpdateSuccess,
  AssessmentProjectUpdateError
} from '../../actions';
 
export function* watchAssessmentProjectList() {
  yield takeEvery(ASSESSMENT_PROJECT_LIST, onAssessmentProjectList);
}

export function* watchAssessmentProjectSearchAssessmentType() {
  yield takeEvery(ASSESSMENT_PROJECT_SEARCH_ASSESSMENT_TYPE, onAssessmentProjectSearchAssessmentType);
}

export function* watchAssessmentProjectSearchAssessment() {
  yield takeEvery(ASSESSMENT_PROJECT_SEARCH_ASSESSMENT, onAssessmentProjectSearchAssessment);
}

export function* watchAssessmentProjectSearchDestination() {
  yield takeEvery(ASSESSMENT_PROJECT_SEARCH_DESTINATION, onAssessmentProjectSearchDestination);
}

export function* watchAssessmentProjectSearchContract() {
  yield takeEvery(ASSESSMENT_PROJECT_SEARCH_CONTRACT, onAssessmentProjectSearchContract);
}

export function* watchAssessmentProjectSearchEvaluationState() {
  yield takeEvery(ASSESSMENT_PROJECT_SEARCH_EVALUATION_STATE, onAssessmentProjectSearchEvaluationState);
}

export function* watchAssessmentProjectAdd() {
  yield takeEvery(ASSESSMENT_PROJECT_ADD, onAssessmentProjectAdd);
}

export function* watchAssessmentProjectDetail() {
  yield takeEvery(ASSESSMENT_PROJECT_DETAIL, onAssessmentProjectDetail);
}

export function* watchAssessmentProjectUpdate() {
  yield takeEvery(ASSESSMENT_PROJECT_UPDATE, onAssessmentProjectUpdate);
}

const onAssessmentProjectListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment_project/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAssessmentProjectUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment_project/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAssessmentProjectSearchAssessmentTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAssessmentProjectSearchAssessmentAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAssessmentProjectSearchDestinationAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/destination', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAssessmentProjectSearchContractAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/contract', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAssessmentProjectSearchEvaluationStateAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/evaluation_state', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAssessmentProjectAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment_project/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAssessmentProjectDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment_project/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onAssessmentProjectList(data) {
  try {
    const response = yield call(onAssessmentProjectListAsync, data.payload);
    yield put(AssessmentProjectListSuccess(response.data));
  } catch (error) {
    yield put(AssessmentProjectListError(error));
  }
}

function* onAssessmentProjectSearchAssessmentType(data) {
  try {
    const response = yield call(onAssessmentProjectSearchAssessmentTypeAsync, data.payload);
    yield put(AssessmentProjectSearchAssessmentTypeSuccess(response.data));
  } catch (error) {
    yield put(AssessmentProjectSearchAssessmentTypeError(error));
  }
}

function* onAssessmentProjectSearchAssessment(data) {
  try {
    const response = yield call(onAssessmentProjectSearchAssessmentAsync, data.payload);
    yield put(AssessmentProjectSearchAssessmentSuccess(response.data));
  } catch (error) {
    yield put(AssessmentProjectSearchAssessmentError(error));
  }
}

function* onAssessmentProjectSearchDestination(data) {
  try {
    const response = yield call(onAssessmentProjectSearchDestinationAsync, data.payload);
    yield put(AssessmentProjectSearchDestinationSuccess(response.data));
  } catch (error) {
    yield put(AssessmentProjectSearchDestinationError(error));
  }
}

function* onAssessmentProjectSearchContract(data) {
  try {
    const response = yield call(onAssessmentProjectSearchContractAsync, data.payload);
    yield put(AssessmentProjectSearchContractSuccess(response.data));
  } catch (error) {
    yield put(AssessmentProjectSearchContractError(error));
  }
}

function* onAssessmentProjectSearchEvaluationState(data) {
  try {
    const response = yield call(onAssessmentProjectSearchEvaluationStateAsync, data.payload);
    yield put(AssessmentProjectSearchEvaluationStateSuccess(response.data));
  } catch (error) {
    yield put(AssessmentProjectSearchEvaluationStateError(error));
  }
}

function* onAssessmentProjectAdd(data) {
  try {
      const response = yield call(onAssessmentProjectAddAsync, data);
      yield put(AssessmentProjectAddSuccess(response.data));
  } catch (error) {
      yield put(AssessmentProjectAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onAssessmentProjectDetail(data) {
  try {
    const response = yield call(onAssessmentProjectDetailAsync, data.payload);
    yield put(AssessmentProjectDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AssessmentProjectDetailError(error));
  }
}

function* onAssessmentProjectUpdate(data) {
  try {
      const response = yield call(onAssessmentProjectUpdateAsync, data.payload);
      yield put(AssessmentProjectUpdateSuccess(response.data));
  } catch (error) {
      yield put(AssessmentProjectUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchAssessmentProjectList),
    fork(watchAssessmentProjectSearchAssessmentType),
    fork(watchAssessmentProjectSearchAssessment),
    fork(watchAssessmentProjectSearchDestination),
    fork(watchAssessmentProjectSearchContract),
    fork(watchAssessmentProjectSearchEvaluationState),
    fork(watchAssessmentProjectAdd),
    fork(watchAssessmentProjectDetail),
    fork(watchAssessmentProjectUpdate),
  ]);
} 